import React, { forwardRef } from 'react';
import { Avatar, useTheme } from '@mui/material';
import { COLLECTION_COVER_BORDER_RADIUS } from './consts';

const DSCollectionCoverAvatar = forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof Avatar>
>((props, ref) => {
  const { spacing } = useTheme();
  return (
    <Avatar
      ref={ref}
      {...props}
      sx={{
        ...props.sx,
        width: spacing(40),
        height: spacing(40),
        borderRadius: COLLECTION_COVER_BORDER_RADIUS,
      }}
    />
  );
});

export default DSCollectionCoverAvatar;
